import React, { useRef, useState } from "react";
import "../../styles/AddUser.css";
import { getFileName } from "../../constant/Utils";
import RemainderModal from "../../pages/RemainderModal";
// import SelectFolder from "../../premitives/SelectFolder";

const EditTemplate = ({ template, onSuccess }) => {
  // const [folder, setFolder] = useState({ ObjectId: "", Name: "" });
  const [formData, setFormData] = useState({
    Name: template?.Name || "",
    Note: template?.Note || "",
    Description: template?.Description || "",
    EmailContent: template?.EmailContent || "",
    SendinOrder: template?.SendinOrder ? `${template?.SendinOrder}` : "false",
    TimeToCompleteDays: template?.TimeToCompleteDays || "",
    reminderSettings: template?.reminderSettings || "",
    AutomaticReminders: template?.AutomaticReminders || false
  });
  const remainderModalRef = useRef(null);
  const [showPreview, setShowPreview] = useState(false);

  const handleStrInput = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  // const handleFolder = (data) => {
  //   console.log("handleFolder ", data)
  //   setFolder(data);
  // };

  // Define a function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const remainderData = remainderModalRef.current?.handleSave() ?? null;
    const isChecked = formData.SendinOrder === "true" ? true : false;
    const data = {
      ...formData,
      SendinOrder: isChecked,
      reminderSettings: remainderData,
      AutomaticReminders: remainderData?.enabled
    };
    onSuccess(data);
  };

  return (
    <div className="addusercontainer">
      {showPreview && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
          onClick={() => setShowPreview(false)}
        >
          <div
            className="bg-white rounded p-4 max-w-3xl max-h-[80vh] min-w-[600px] min-h-[300px] overflow-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative mb-4">
              <button
                onClick={() => setShowPreview(false)}
                className="absolute right-0 top-1 text-red-500 font-bold text-2xl leading-none"
                aria-label="Close preview"
              >
                &times;
              </button>
              <h2 className="text-xl font-bold text-center">Preview</h2>
            </div>
            <div
              className="border p-4"
              dangerouslySetInnerHTML={{
                __html: formData.EmailContent || "<p>No content available</p>"
              }}
            />
          </div>
        </div>
      )}

      <div
        className="form-wrapper"
        style={{ maxHeight: "80vh", overflowY: "auto" }}
      >
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="name" style={{ fontSize: 13 }}>
              File
            </label>
            <div
              style={{
                padding: "0.5rem 0.75rem",
                border: "1px solid #d1d5db",
                borderRadius: "0.375rem",
                fontSize: "0.75rem",
                fontWeight: "700"
              }}
            >
              {getFileName(template.URL)}
            </div>
          </div>
          <div className="form-section">
            <label htmlFor="name" style={{ fontSize: 13 }}>
              Name
              <span style={{ color: "red", fontSize: 13 }}> *</span>
            </label>
            <input
              type="text"
              name="Name"
              value={formData.Name}
              onChange={(e) => handleStrInput(e)}
              required
              className="addUserInput"
            />
          </div>
          <div className="form-section">
            <label htmlFor="Note" style={{ fontSize: 13 }}>
              Note
            </label>
            <input
              type="text"
              name="Note"
              id="Note"
              value={formData.Note}
              onChange={(e) => handleStrInput(e)}
              className="addUserInput"
            />
          </div>
          <div className="form-section">
            <div className="d-flex">
              <label
                className="flex-1"
                htmlFor="EmailContent"
                style={{ fontSize: 13 }}
              >
                Email Content
              </label>
              <button
                type="button"
                onClick={() => setShowPreview(true)}
                className="px-3 py-2 bg-blue-500 text-white rounded text-xs hover:bg-blue-600 focus:outline-none flex-2"
                disabled={!formData.EmailContent}
              >
                Preview
              </button>
            </div>
            <textarea
              id="EmailContent"
              name="EmailContent"
              rows={4}
              value={formData.EmailContent}
              onChange={(e) => handleStrInput(e)}
              className="addUserInput"
              cols="150"
            />
          </div>
          <div className="form-section">
            <label htmlFor="Description" style={{ fontSize: 13 }}>
              Description
            </label>
            <input
              type="text"
              name="Description"
              id="Description"
              value={formData.Description}
              onChange={(e) => handleStrInput(e)}
              className="addUserInput"
            />
          </div>
          <div className="text-xs mt-2">
            <label className="block">
              Time To Complete (Days)
              <span className="text-red-500 text-[13px]">*</span>
            </label>
            <input
              type="number"
              name="TimeToCompleteDays"
              className="px-3 py-2 w-full border-[1px] border-gray-300 rounded focus:outline-none text-xs"
              value={formData.TimeToCompleteDays}
              onChange={(e) => handleStrInput(e)}
              required
            />
          </div>
          <div className="form-section">
            <label style={{ fontSize: 13 }}>Send In Order</label>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                marginLeft: 8,
                marginBottom: 5
              }}
            >
              <input
                type="radio"
                value={"true"}
                name="SendinOrder"
                checked={formData.SendinOrder === "true"}
                onChange={handleStrInput}
              />
              <div style={{ fontSize: 12 }}>Yes</div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                marginLeft: 8,
                marginBottom: 5
              }}
            >
              <input
                type="radio"
                value={"false"}
                name="SendinOrder"
                checked={formData.SendinOrder === "false"}
                onChange={handleStrInput}
              />
              <div style={{ fontSize: 12 }}>No</div>
            </div>
          </div>
          <RemainderModal
            data={formData.reminderSettings}
            ref={remainderModalRef}
          />
          {/* <SelectFolder onSuccess={handleFolder} folderCls={"contracts_Template"} /> */}
          <div className="buttoncontainer">
            <button type="submit" className="submitbutton">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditTemplate;
